(() => {
  if (customElements.get('tlc-breed-options')) return;
  const normalize = value => String(value ?? '').trim().toLowerCase();
  const exactVariant = (variants, color, size) => variants.find(v => normalize(v.option1) === normalize(color) && normalize(v.option2) === normalize(size));
  class TlcBreedOptions extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.status = this.querySelector('[role="status"]');
      if (!this.select || this.bound) return;
      this.bound = true;
      this.querySelector('[data-breed-control]').hidden = false;
      this.events = new AbortController();
      this.select.addEventListener('change', () => this.changeBreed(), {signal:this.events.signal});
      window.addEventListener('pageshow', () => {this.select.disabled = false; this.select.value = this.dataset.current;}, {signal:this.events.signal});
    }
    disconnectedCallback() {this.events?.abort(); this.bound = false;}
    async changeBreed() {
      if (this.select.value === this.dataset.current) return;
      const picker = document.querySelector(`variant-picker[data-product-id="${this.dataset.sourceProduct}"][data-template-product-match="true"]`);
      const color = picker?.querySelector('input[data-fieldset-index="0"]:checked, select[name="options[Color]"]')?.value;
      const size = picker?.querySelector('input[data-tlc-size-input]:checked, select[data-tlc-size-input]')?.value;
      if (!color || !size) return this.fail(this.dataset.unavailable);
      const selected = this.select.selectedOptions[0];
      const destination = new URL(selected.dataset.productUrl, location.href);
      if (destination.origin !== location.origin || !destination.pathname.includes('/products/')) return this.fail(this.dataset.error);
      this.select.disabled = true;
      this.status.hidden = false;
      this.status.textContent = this.dataset.loading;
      try {
        const response = await fetch(destination.pathname + '.js', {credentials:'same-origin',headers:{Accept:'application/json'},signal:AbortSignal.timeout(12000)});
        if (!response.ok) throw new Error('Product unavailable');
        const product = await response.json();
        if (!this.isConnected) return;
        if (product.handle !== destination.pathname.split('/').pop() || !Array.isArray(product.variants)) throw new Error('Unexpected product');
        const latestColor = picker?.querySelector('input[data-fieldset-index="0"]:checked, select[name="options[Color]"]')?.value;
        const latestSize = picker?.querySelector('input[data-tlc-size-input]:checked, select[data-tlc-size-input]')?.value;
        const target = exactVariant(product.variants, latestColor, latestSize);
        if (!target || !/^\d+$/.test(String(target.id))) return this.fail(this.dataset.unavailable);
        destination.searchParams.set('variant', target.id);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview && /^\d+$/.test(preview)) destination.searchParams.set('preview_theme_id', preview);
        try {document.activeViewTransition?.skipTransition();} catch {}
        location.assign(destination.href);
      } catch {this.fail(this.dataset.error);}
    }
    fail(message) {
      this.select.value = this.dataset.current;
      this.select.disabled = false;
      this.status.hidden = false;
      this.status.textContent = message;
    }
  }
  customElements.define('tlc-breed-options', TlcBreedOptions);
})();
